import type { ContentKind, StorylineKind } from '@airpost/shared';

/** The storyline's box icons: the boxes in the story editor, and what a story holds in Οδηγός Δελτίου. */
export const ICON: Record<StorylineKind, string> = { read: '🎙', video: '🎬', title: '🅰', sot: '💬', reporter: '👤', card: '🃏', natsound: '🔊', promo: '📣', note: '📝' };
/** Pictures without their sound (ΒΙΝΤΕΟ VO). */
export const ICON_VO = '🎞';

/** What a story holds, as the rundown shows it after its title: the icon and the box's name. */
export const CONTENT_ICON: Record<ContentKind, { icon: string; name: string }> = {
  'video-sound': { icon: ICON.video, name: 'ΒΙΝΤΕΟ ΜΕ ΗΧΟ' },
  'video-vo': { icon: ICON_VO, name: 'ΒΙΝΤΕΟ VO' },
  title: { icon: ICON.title, name: 'ΤΙΤΛΟΣ (lower third)' },
  sot: { icon: ICON.sot, name: 'ΔΗΛΩΣΗ' },
  reporter: { icon: ICON.reporter, name: 'ΡΕΠΟΡΤΑΖ' },
  card: { icon: ICON.card, name: 'ΚΑΡΤΑ' },
  natsound: { icon: ICON.natsound, name: 'ΦΥΣΙΚΟΣ ΗΧΟΣ' },
  promo: { icon: ICON.promo, name: 'ALPHANEWS.LIVE' },
};

/** The words of a row's icons: `2 × ΒΙΝΤΕΟ ΜΕ ΗΧΟ · ΤΙΤΛΟΣ (lower third)`. */
export const contentsText = (contents: ReadonlyArray<{ kind: ContentKind; n: number }>): string => contents.map((c) => `${c.n > 1 ? `${c.n} × ` : ''}${CONTENT_ICON[c.kind].name}`).join(' · ');
